<!-- Copyright (c) ArubaCC - All Rights Reserved. -->

<div class="flex flex-col w-full h-full overflow-hidden">
  <div class="flex h-full">
    @if (($breakpoints | async)!.isXSmall || !isDetailExpanded) {
      <div
      [ngClass]="{
        'w-full': !selectedItem,
        'w-1/3': selectedItem && !($breakpoints | async)!.isHandsetLayout,
        hidden: ($breakpoints | async)!.isHandsetLayout && selectedItem,
      }"
        >
        <ng-content select="[list]"></ng-content>
      </div>
    }

    <div
      [ngClass]="{
        hidden: ($breakpoints | async)!.isHandsetLayout && !selectedItem,
        'flex-grow': !detailFullWidth,
        'w-full': detailFullWidth,
      }"
      class="h-full flex flex-col p-3 bg-white border border-solid border-detail-list-border overflow-hidden"
      >
      @if (selectedItem) {
        <div class="flex justify-end">
          @if (!($breakpoints | async)!.isHandsetLayout) {
            <button
              type="button"
              (click)="onExpand()"
              mat-icon-button
              >
              <mat-icon svgIcon="expand"></mat-icon>
            </button>
          }
          <button type="button" (click)="onClose()" mat-icon-button>
            <mat-icon svgIcon="close"></mat-icon>
          </button>
        </div>
      }
      @if (selectedItem) {
        <ng-content select="[detail]"></ng-content>
      }
    </div>
  </div>
</div>
